import type { ApolloCache } from "@apollo/client";
import { insertIntoConnection, removeFromConnection } from "#app/lib/data/connection-cache-utils";

// IssueSource has no keyFields override in the Apollo type policies, so the
// cache keys it by `id` — identifiers passed to the connection helpers must
// carry `id`, never the legacy-style `issueSourceId` twin (toReference answers
// undefined for an object it cannot key, and the helpers then no-op).

export function addIssueSourceToCache(cache: ApolloCache, issueSource: { id: string }) {
  insertIntoConnection(cache, "issueSources", "IssueSourceEdge", {
    __typename: "IssueSource",
    id: issueSource.id,
  });
}

export function removeIssueSourceFromCache(cache: ApolloCache, issueSource: { id: string }) {
  removeFromConnection(
    cache,
    "issueSources",
    { __typename: "IssueSource", id: issueSource.id },
    { evict: true },
  );
}
